import { useCallback, useMemo, useEffect, useRef } from 'react';
// import { fetchToken, onMessageListener } from "./firebase";
import { useDispatch, useSelector } from 'react-redux';
import { appDetailsByTenant, getDynamicMenus, setChartAttributes } from './redux/actions/appInfo';
import { getDPDetailsEDIS, getDeviceInfo, updateCft, updateUserId, userLoginSuccess, userLogout, userSwitch } from './redux/actions/auth';
import Navigation from './navigation';
import {
    getAppInfoData, getIsConfigExist, setActiveTheme, getClientFacilityTemplate, setEncryptLocalStorage, getDecryptLocalStorage,
    getKeys, getUserLoggedIn, getApiExchangeNameFromMktSegId, bIsProd, getStorageWithMultiTabCheck, onUserLoggedInActiveSession,
    getExchangeName, getStorageWithMultiTabCheckWithoutEncryption, setStorageWithMultiTabCheckWithoutEncryption,
    getActiveUser,
} from './utils/global_functions';
import { APP_INFO_PARAMS, DEEP_LINK, LOCATIONS, LOCAL_STORAGE_KEYS, ORDER_PRODUCT_TYPES, THEME_TYPE, APP_INFO_DEFAULT_VALUES, MESSAGE_SOCKET_MSG_TYPE, ORDER_ENTRY_BUY_SELL_TEXT, DISPLAY_EXCHANGE_NAME } from './utils/global_variables'; //Prachi T [06-12-2023] : Breeze- Font and Colour Settings
import { getProductTypes } from './redux/actions/orders';
import config from './config.json';
import { _getExchangeTypes, _handleTrialExpired, _storeQueryParams } from './controllers';
import { CloseAccountModal } from './containers/UserProfile';
import { OptionChainModal } from './containers/Search';
import { Header, SSOLinksModal } from './containers';
//Prachi T - 16-11-2023 - BT-110050 - Breeze- Settings Preferences - Start
import { fetchToken, onMessageListener } from './firebase';
import { pushNotificationTopicSubUnsub, reSubUnSubPushNotificationTopic } from './redux/actions/setting'; //Prachi T - 05-12-2023 - BT-109052 - Breeze- Font and Colour Settings
import { _checkIsFirstLoginOfDay } from './controllers/edis';
import { updateReconnectionCount } from './redux/actions/wfh';
import { getTotalPages } from './redux/actions/globalSearch';
import ReactGA from "react-ga4";
import { _getOrderEntryAllExchangeWiseProductTypes } from './controllers/orders';
import { updateUserPreference } from './redux/actions/header';
import { useLocation, useNavigate } from 'react-router';
import useIsDevToolsOpen from './hooks/detectDevTools';
import { handleModal } from './redux/actions/modals';
import useIdleLock from './hooks/useIdleLock';
import AutoLockModal from './containers/Header/AutoLockModal';
import { addSocketEventListener, connectSocket, disconnectSocket, emitSocketEvent } from './apis/message_socket';
import { toastConfig } from './redux/actions/toast';
import { getMessagesOrders, updateMsgActiveChip } from './redux/actions/messages';
import EventDetailsModal from './containers/Events/EventDetailsModal';

// const TRACKING_ID = "G-B8W5FSH18L";

// ReactGA.initialize(TRACKING_ID); // DO NOT REMOVE.


const App = () => {
    const dispatch = useDispatch();
    const { appInfo } = useSelector(state => state.appInfo);
    const dynamicMenus = useSelector(state => state?.appInfo?.dynamicMenus);
    const location = useLocation();
    const dontMissrefreshTimer = getAppInfoData(APP_INFO_PARAMS.APP_DONTMISS_REFRESH_TIMER, APP_INFO_DEFAULT_VALUES.MINIMUM_INTERVAL_TIME_FOR_WHATSHOTDATA_CALL);
    const nWhatsHotDataIntervalTime = useMemo(() => appInfo?.length > 0 && dontMissrefreshTimer >= APP_INFO_DEFAULT_VALUES.MINIMUM_INTERVAL_TIME_FOR_WHATSHOTDATA_CALL ? dontMissrefreshTimer * 60 * 1000 : APP_INFO_DEFAULT_VALUES.MINIMUM_INTERVAL_TIME_FOR_WHATSHOTDATA_CALL * 60 * 1000, [appInfo]);
    const modals = useSelector(state => state.modals.modals);
    const userPreference = useSelector(state => state.notification.userPreference);
    const objLoginSession = useSelector(state => state?.auth?.objLoginSession);
    const userId = useSelector(state => state.auth?.userId);
    const webTopicSubUnSubResp = useSelector(state => state?.setting?.webTopicSubUnSubResp); //Prachi T - 05-12-2023 - BT-109052 - Breeze- Font and Colour Settings
    // Ajitesh : 02/01/2024: BT-109135: Breeze eDIS implementation centralised edis summary api call - Start
    const loginSessionInfo = getStorageWithMultiTabCheck(LOCAL_STORAGE_KEYS.USER_ACTIVE_SESSION);
    // Ajitesh : 02/01/2024: BT-109135: Breeze eDIS implementation centralised edis summary api call - Start
    const reconnectionCount = useSelector(state => state?.wfh?.reconnectionCount);
    const deviceInfo = useSelector(state => state?.auth?.deviceInfo);
    const autoLockActiveUserObj = JSON.parse(getDecryptLocalStorage(LOCAL_STORAGE_KEYS.AUTO_LOCK_SESSIONS))?.[getActiveUser(objLoginSession)];
    const isAutoLocked = autoLockActiveUserObj?.isModalOpen;
    const timeout = autoLockActiveUserObj?.timeout ? parseInt(autoLockActiveUserObj?.timeout, 10) * 60 * 1000 : null;
    useEffect(() => {//blocking key press if modal is open
        const handleKeyDown = (event) => {
            if (isAutoLocked) {
                const blockedKeys = [
                    'Tab',
                    'Shift',
                    'Alt',
                    'Escape',
                    'Delete',
                    'Control',
                    // Function keys
                    'F1', 'F2', 'F3', 'F4', 'F5', 'F6',
                    'F7', 'F8', 'F9', 'F10', 'F11', 'F12'
                ];
                if (blockedKeys.includes(event.key)) {
                    event.preventDefault();
                    event.stopImmediatePropagation();
                }
            }
        };

        const events = ['keyup', 'keydown', 'keypress'];
        events.forEach(each => window.addEventListener(each, handleKeyDown, true));//capturing event

        return () => window.removeEventListener('keydown', handleKeyDown, true);
    }, [isAutoLocked]);


    useIdleLock({//Hook that calls autolock after being idle for timeout
        timeout: timeout,
        onLock: () => {
            const activeUser = getActiveUser(objLoginSession);
            const autoLockSessionObj = JSON.parse(getDecryptLocalStorage(LOCAL_STORAGE_KEYS.AUTO_LOCK_SESSIONS));
            const newobj = { ...autoLockSessionObj, [activeUser]: { ...autoLockSessionObj?.[activeUser], isModalOpen: true } };
            setEncryptLocalStorage(LOCAL_STORAGE_KEYS.AUTO_LOCK_SESSIONS, JSON.stringify(newobj));
            dispatch(handleModal([{ 'AUTO_LOCK_MODAL': true }]));
        },
        onUnlock: () => {
            const activeUser = getActiveUser(objLoginSession);
            const autoLockSessionObj = JSON.parse(getDecryptLocalStorage(LOCAL_STORAGE_KEYS.AUTO_LOCK_SESSIONS));
            const newobj = { ...autoLockSessionObj, [activeUser]: { ...autoLockSessionObj?.[activeUser], isModalOpen: false } };
            setEncryptLocalStorage(LOCAL_STORAGE_KEYS.AUTO_LOCK_SESSIONS, JSON.stringify(newobj));
            dispatch(handleModal([{ 'AUTO_LOCK_MODAL': false }]));
        }
    });

    // Function to handle click of view button from within message socket toast
    const handleViewMessages = useCallback((btnType) => {
        if (btnType === "view") {
            dispatch(handleModal([{ "ORDER_STATUS": false }]));
            dispatch(updateMsgActiveChip("order"));
            // trigger an api call for orderMessages again, so all latest order notifs can be fetched; at the moment, if user has opened notif window and fetched all notifs, then after placing new order no more notifs will be fetched
            dispatch(getMessagesOrders({ pageNo: 1 }));
            dispatch(handleModal([{ "MESSAGES": true }]));
        }
        else {
            dispatch(toastConfig({ show: false }));
        }
    }, [dispatch]);

    // Breeze- 9633 LLD: Message Socket implementation
    useEffect(() => {
        if (Object.keys(objLoginSession).length && objLoginSession?.data?.others) {
            // Trigger socket connection flow via newly created utlity methods as soon as user logs in
            connectSocket(objLoginSession.data.others.messageSocket, {
                reconnection: true,
                autoConnect: true,
                reconnectionAttempts: getAppInfoData(APP_INFO_PARAMS.APP_SOCKET_IO_RECONNECTION_RETRY_COUNT, 10),
                reconnectionDelay: getAppInfoData(APP_INFO_PARAMS.APP_SOCKET_RECONNECTION_TIME_VALUE, 2000),
                timeout: 3000,
            }).then(() => {
                // emit login event
                emitSocketEvent("loginAPI", {
                    jToken: objLoginSession.data.access_token,
                    jRequestID: `${new Date().getHours()}${new Date().getMinutes()}${new Date().getSeconds()}${new Date().getMilliseconds()}`,
                    messageSocket: objLoginSession.data.others.messageSocket,
                });

                // listen for MSG:DATA event through utlity method
                addSocketEventListener("MSG:DATA", (msgData) => {
                    if (msgData.MessageType === MESSAGE_SOCKET_MSG_TYPE.OMEX_MESSAGETYPE_ORDER ||
                        msgData.MessageType === MESSAGE_SOCKET_MSG_TYPE.OMEX_MESSAGETYPE_TRADE ||
                        msgData.MessageType === MESSAGE_SOCKET_MSG_TYPE.OMEX_MESSAGETYPE_POS_CONV ||
                        msgData.MessageType === MESSAGE_SOCKET_MSG_TYPE.OMEX_MESSAGETYPE_GTD_ORDER) {
                        let exchangeName = getExchangeName(msgData.Exchange);
                        let buySell = msgData.Buy_Sell === '1' ? ORDER_ENTRY_BUY_SELL_TEXT.BUY : ORDER_ENTRY_BUY_SELL_TEXT.SELL;
                        let price = (exchangeName === DISPLAY_EXCHANGE_NAME.NSX_EXCHANGE_TEXT || DISPLAY_EXCHANGE_NAME.BSECDX_EXCHANGE_TEXT) ? (msgData.OrderPrice / 10000000).toFixed(4) : (msgData.OrderPrice / 100).toFixed(2);
                        switch (msgData.MessageType) {
                            case MESSAGE_SOCKET_MSG_TYPE.OMEX_MESSAGETYPE_TRADE:
                                let _Msg = msgData.TradeTime + ' ' + exchangeName + ' ' + buySell + ' ' + msgData.Symbol + ' ' + msgData.Series + ' ' + msgData.TradeQty + ' @ ' +
                                    price + ' Order # ' + msgData.OrderNumber;
                                dispatch(toastConfig({
                                    show: true, autoDismiss: true, timer: 5000, message: _Msg, realTimeMsg: true,
                                    button: [
                                        { btnName: "View", onClickHandler: () => handleViewMessages("view"), className: "btn btn-outline-active ms-3" },
                                        { btnName: "Dismiss", onClickHandler: () => handleViewMessages("dismiss"), className: "btn btn-outline-active ms-3" },
                                    ]
                                }));
                                break;
                            case MESSAGE_SOCKET_MSG_TYPE.OMEX_MESSAGETYPE_POS_CONV:
                                let position_conv_msg = `Position conversion for ${msgData.Symbol} ${msgData.Reason.length > 0 ? `is failed.\nKindly check Messages page for more info.` : `is successful.`}`;
                                dispatch(toastConfig({
                                    show: true, autoDismiss: true, timer: 5000, message: position_conv_msg, realTimeMsg: true,
                                    button: [
                                        { btnName: "View", onClickHandler: () => handleViewMessages("view"), className: "btn btn-outline-active ms-3" },
                                        { btnName: "Dismiss", onClickHandler: () => handleViewMessages("dismiss"), className: "btn btn-outline-active ms-3" },
                                    ]
                                }));
                                break;
                        }
                    }
                });
            }).catch((err) => {
                console.error(err);
            });
        }
        return () => {
            disconnectSocket();
        };
    }, [objLoginSession, dispatch, handleViewMessages]);
    //Breeze- 9633 LLD: Message Socket implementation

    //Ameersha N -- TO open Devtools msg modal  on devtools open --Start
    if (useIsDevToolsOpen() && bIsProd()) {
        // here modal should be opned
        // if modal is not opned then only open modal
        if (!modals['DEV_TOOLS_MODAL']) {
            dispatch(handleModal([{ 'DEV_TOOLS_MODAL': true }]));
        } else { }
    } else {
        //if model opened then onky it shoudl be closed
        if (modals['DEV_TOOLS_MODAL']) {
            dispatch(handleModal([{ 'DEV_TOOLS_MODAL': false }]));
        } else { }
    };
    //Ameersha N -- TO open Devtools msg modal  on devtools open --End


    // Shuaib : 21/02/2024: Reconnection attempts - Start
    useEffect(() => {
        if (appInfo?.length > 0 && reconnectionCount === null) {
            let count = getAppInfoData(APP_INFO_PARAMS.APP_SOCKET_RECONNECTION_RETRY_COUNT, APP_INFO_DEFAULT_VALUES.DEFAULT_SOCKET_RECONNECTION_RETRY_COUNT);
            if (count) {
                dispatch(updateReconnectionCount(count));
            } else {
            }
        }
    }, [appInfo, reconnectionCount, dispatch]);
    // Shuaib : 21/02/2024: Reconnection attempts - End


    // Shuaib : 07/04/2024:Updating Pages --Start
    useEffect(() => {
        if (Object.keys(dynamicMenus)?.length) {
            dispatch(getTotalPages());
        }
    }, [dynamicMenus, dispatch]);

    // Shuaib : 07/04/2024: Updating Pages --End

    //Prachi T - 16-11-2023 - BT-110050 - Breeze- Settings Preferences - Start
    const currentPreferenceFontSize = useMemo(() => {
        if (userPreference?.length) {

            const sortedUsers = [...userPreference].sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));
            const currentUserPreference = { ...sortedUsers[0] };
            const fontColorSize = currentUserPreference?.sInAppNotification ? JSON.parse(currentUserPreference?.sInAppNotification) : {};
            //Prachi T [06-12-2023] : Breeze- Font and Colour Settings - Start
            if (currentUserPreference?.sTheme === THEME_TYPE.DARK) {
                document.body.classList.add(THEME_TYPE.DARK);
                setEncryptLocalStorage(LOCAL_STORAGE_KEYS.THEME, THEME_TYPE.DARK);
            } else {
                document.body.classList.remove(THEME_TYPE.DARK);
                localStorage.removeItem(LOCAL_STORAGE_KEYS.THEME);
            }
            //Prachi T [06-12-2023] : Breeze- Font and Colour Settings - End
            return fontColorSize?.font;
        }
        else {
            return '';
        }
    }, [userPreference]);
    //Prachi T - 16-11-2023 - BT-110050 - Breeze- Settings Preferences - End


    const onInitilize = useCallback(async () => {
        var objLoginSession = getStorageWithMultiTabCheck(LOCAL_STORAGE_KEYS.USER_ACTIVE_SESSION);
        if (objLoginSession) {
            objLoginSession = JSON.parse(objLoginSession);
            if (location.pathname !== LOCATIONS.ORDERS) {
                dispatch(getProductTypes());
            }
        } else {
            objLoginSession = {};
        }
        //BT-120013 : Bug Fixing : Guest Login : Manasa B : 20/10/2023 - Start
        if (objLoginSession?.guestMode) {
            const objTrialExpiredResponse = _handleTrialExpired(appInfo, objLoginSession?.userId);
            if (objTrialExpiredResponse?.status) {
                if (objTrialExpiredResponse?.data) {
                    dispatch(userLogout()).then(() => {
                        window.location.replace('/');
                    }).catch(() => {
                        window.location.replace('/');
                    });
                }
                else {
                    handleNormalFlow(objLoginSession);
                }
            }
        }
        else {
            handleNormalFlow(objLoginSession);
        }

    }, [appInfo, dispatch]);

    const hasFetchedData = useRef(false);
    const handleNormalFlow = async (objLoginSession) => {
        const bIsConfig = getIsConfigExist();
        if (bIsConfig) {
            if (localStorage.getItem(LOCAL_STORAGE_KEYS.SERVER_KEY) == null && localStorage.getItem(LOCAL_STORAGE_KEYS.HEADER) == null && !hasFetchedData.current) {
                hasFetchedData.current = true;
                await getKeys();
            }
            if (appInfo?.length === 0) {
                if (localStorage.getItem(LOCAL_STORAGE_KEYS.SERVER_KEY) !== null && localStorage.getItem(LOCAL_STORAGE_KEYS.HEADER) !== null) {
                    await dispatch(appDetailsByTenant());
                    //Maaz A : 30-08-2023 : BT-116689 - Breeze - Create Dynamic Menu - Start
                    dispatch(getDynamicMenus());
                    //Maaz A : 30-08-2023 : BT-116689 - Breeze - Create Dynamic Menu - End
                    dispatch(updateUserId(objLoginSession?.data?.user_id));
                    dispatch(userLoginSuccess(objLoginSession));
                    setActiveTheme();
                    const storedChartAttributes = JSON.parse(getDecryptLocalStorage(LOCAL_STORAGE_KEYS.CHART_URL_ATTRIBUTES));
                    if (storedChartAttributes) {
                        dispatch(setChartAttributes({ ...storedChartAttributes }));
                    }
                }
            } else {
                const cft = getClientFacilityTemplate(objLoginSession?.data?.others?.CFT, appInfo);
                dispatch(updateCft(cft));
            }
            // Ajitesh : 16/11/2023: BT-109135: Breeze eDIS implementation - Start
            if (Object.keys(objLoginSession).length) {
                if (!Object?.keys(objLoginSession)?.includes('guestMode')) {
                    dispatch(getDPDetailsEDIS());
                } else { }

            }
            // Ajitesh : 16/11/2023: BT-109135: Breeze eDIS implementation - End
        } else {
            if (window.location.pathname === '/') {
                window.location.replace('/environmentSetting');
            } else { }
        }
    };
    const getPos = useCallback((pos) => {
        if (appInfo?.length) {
            let verNo = getAppInfoData(APP_INFO_PARAMS.APP_BREEZE_VERSION);
            let temp = {
                "deviceinfo": {
                    "DeviceSerialNo": window.navigator.productSub,
                    "DeviceManufacturer": window.navigator.vendor,
                    "DevicePlatform": "Breeze",
                    "DevicePlatformVer": window.navigator.userAgent,
                    "Longitude": pos?.coords?.longitude || "",
                    "Latitude": pos?.coords?.latitude || "",
                    "AppName": "Breeze",
                    "AppVersion": window.navigator.appVersion,
                    "AppVersionCode": verNo,
                    "FCMRegKey": window.location.host, //initiaise se registered key => app.
                }
            };
            dispatch(getDeviceInfo(temp?.deviceinfo));
            setEncryptLocalStorage(LOCAL_STORAGE_KEYS.DEVICE_INFO, JSON.stringify(temp?.deviceinfo));
        }
    }, [appInfo, dispatch]);

    useEffect(() => {
        if (!deviceInfo) {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(getPos, getPos);
            }
        }
    }, [getPos, deviceInfo]);

    //BT-120013 : Bug Fixing : Guest Login : Manasa B : 20/10/2023 - End


    // Azeem K :29-05-2024 : seprated useEffect for BT-109052 - Breeze- Font and Colour Settings - Start
    useEffect(() => {
        let interval;

        if (nWhatsHotDataIntervalTime) {
            interval = setInterval(() => {

                //Prachi T - 05-12-2023 - BT-109052 - Breeze- Font and Colour Settings - Start
                if (webTopicSubUnSubResp && Object.keys(webTopicSubUnSubResp)?.length && !webTopicSubUnSubResp?.status) {
                    const subList = webTopicSubUnSubResp?.result?.subList?.fail;
                    const unSublist = webTopicSubUnSubResp?.result?.unSublist?.fail;
                    const fcmToken = getDecryptLocalStorage(`FCM_TOKEN_${userId}`);
                    dispatch(reSubUnSubPushNotificationTopic({ fcmToken, subList, unSublist }));
                }
                //Prachi T - 05-12-2023 - BT-109052 - Breeze- Font and Colour Settings - End
            }, nWhatsHotDataIntervalTime);
        } else { }

        return (() => {
            clearInterval(interval);
        });
    }, [nWhatsHotDataIntervalTime, userId, webTopicSubUnSubResp, dispatch]); //Prachi T - 05-12-2023 - BT-109052 - Breeze- Font and Colour Settings
    // Azeem K :29-05-2024 : seprated useEffect for BT-109052 - Breeze- Font and Colour Settings - End


    useEffect(() => {
        _storeQueryParams();
    }, [objLoginSession]);

    useEffect(() => {
        onInitilize();
    }, [onInitilize]);

    //Prachi T - 16-11-2023 - BT-110050 - Breeze- Settings Preferences - Start
    useEffect(() => {
        if (userId && userPreference?.length) {
            const sortedUsers = [...userPreference].sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));
            const currentUserPreference = { ...sortedUsers[0] };
            const topicList = currentUserPreference?.sNotification ? JSON.parse(currentUserPreference?.sNotification) : [];

            const supportNotification = "Notification" in window;
            if (supportNotification) {
                Notification.requestPermission()
                    .then(permission => {
                        if (permission === 'granted') {
                            //firebase notification
                            fetchToken(userId, () => {
                                dispatch(pushNotificationTopicSubUnsub(topicList));
                            });
                        }
                    }).catch(err => console.log(err));
            } else {
                console.log("notification not supported on this device");

            }
        }
    }, [userId, userPreference, dispatch]);

    onMessageListener((payload) => {
        new Notification(payload?.notification?.title);
    });
    //Prachi T - 16-11-2023 - BT-110050 - Breeze- Settings Preferences - End


    //Maaz A : 05-10-2023 : BT-102298 - Breeze - Single Scrip Order entry - Start
    useEffect(() => {
        // for the disabling right click / contextmenu event
        const handleContextMenu = (e) => {
            // prevent the right-click menu from appearing
            e.preventDefault();
        };

        document.addEventListener("contextmenu", handleContextMenu);
        return () => {
            document.removeEventListener("contextmenu", handleContextMenu);
        };
    }, []);
    //Maaz A : 05-10-2023 : BT-102298 - Breeze - Single Scrip Order entry - End


    useEffect(() => {
        if (getDecryptLocalStorage(DEEP_LINK) !== null) {
            const pageToNavigate = JSON.parse(getDecryptLocalStorage(DEEP_LINK));
            setEncryptLocalStorage(LOCAL_STORAGE_KEYS.SELECTED_ROUTE, pageToNavigate?.navigate);
        }
    }, []);

    // Ajitesh : 10/01/2024: BT-109135: Breeze eDIS implementation - Store and check first login of day in localStorage - Start
    useEffect(() => {
        if (loginSessionInfo && JSON.parse(loginSessionInfo)) {
            _checkIsFirstLoginOfDay(loginSessionInfo);
        }
    }, [loginSessionInfo]);
    // Ajitesh : 10/01/2024: BT-109135: Breeze eDIS implementation - Store and check first login of day in localStorage - End



    useEffect(() => {
        ReactGA.send({ hitType: 'pageview', page: window.location.pathname + window.location.search, title: 'Custom Title from Breeze' });
    }, [location]);


    /*  Shuaib P [14/05/2024] - consoling build details --Start*/

    useEffect(() => {
        if (config) {
            document.title = config.Title;
            const url = config.Wave.URL;
            const environment = bIsProd() ? 'PROD' : 'DEV';
            const tenant = config.TenantId;
            let wfhConnectionString;
            let messageSocket;
            let strActiveSession = getStorageWithMultiTabCheck(LOCAL_STORAGE_KEYS.USER_ACTIVE_SESSION);
            if (strActiveSession) {
                let objActiveSession = JSON.parse(strActiveSession);
                wfhConnectionString = objActiveSession?.data?.others?.broadCastSocket;
                messageSocket = objActiveSession?.data?.others?.messageSocket;
            }
            let infoTable = {
                'URL': url,
                'Tenant': tenant,
                'BCast': wfhConnectionString,
                'Msg': messageSocket,
                'Environment': environment,
                'Build Date': config.buildDate,
                'Build Version': config.buildVersion,
                'Branch': config.branch
            };
            setEncryptLocalStorage(LOCAL_STORAGE_KEYS.SOCKET_HEALTH_INFO, JSON.stringify(infoTable));
        }

    }, []);

    /*  Shuaib P [14/05/2024] - consoling build details --End*/
    const productTypes = useSelector(state => state.orders.productTypes);

    useEffect(() => {
        const exchanges = objLoginSession?.data?.exchanges;

        if (userPreference?.length) {
            const objActiveUserPreference = userPreference[userPreference?.length - 1];

            const sortedUsers = [...userPreference].sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));
            const currentUserPreference = { ...sortedUsers[0] };
            const currentPreference = currentUserPreference;
            const objDefaultProdTypes = getAppInfoData(APP_INFO_PARAMS.APP_DEFAULT_PRODUCT);

            let arrExchangeTypes = [];
            if (currentPreference) {
                arrExchangeTypes = _getExchangeTypes(exchanges, currentPreference);
            }

            const userPreferenceExchanges = currentPreference?.sExchange?.length ? JSON.parse(currentPreference?.sExchange) : [];

            const arrNewUserPreferenceExchanges = [];
            arrExchangeTypes?.forEach((objExchange) => {
                const nIndx = userPreferenceExchanges?.findIndex(exchangType => exchangType?.exchange === objExchange?.exchange);
                if (nIndx < 0) {
                    // if exchange is not in userPreference
                    const strrExchange = getApiExchangeNameFromMktSegId(objExchange.marketSegmentId);
                    let strProductTypeFromAppinfo = objDefaultProdTypes[strrExchange];//product type from member /appInfo
                    if (strrExchange.includes('EQ') && strProductTypeFromAppinfo === ORDER_PRODUCT_TYPES.INTRADAY) {
                        strProductTypeFromAppinfo = ORDER_PRODUCT_TYPES.MARGIN;
                    } else if (!strrExchange.includes('EQ') && strProductTypeFromAppinfo === ORDER_PRODUCT_TYPES.DELIVERY) {
                        strProductTypeFromAppinfo = ORDER_PRODUCT_TYPES.CARRYFORWARD;
                    }

                    const objResp = _getOrderEntryAllExchangeWiseProductTypes(productTypes, strrExchange, objLoginSession);
                    const arrAllExchangeWiseProductTypes = objResp?.data || [];//array of products allowed to user for particular exchange/segment
                    if (arrAllExchangeWiseProductTypes?.length > 0) {
                        let tempObj = { ...objExchange };
                        const objDefaultType = arrAllExchangeWiseProductTypes?.find((product) => product?.sDefaultProductType === strProductTypeFromAppinfo);
                        if (objDefaultType) {
                            tempObj.productType = objDefaultType?.sDefaultProductType;
                        } else {
                            // for EQ
                            if (strrExchange?.includes('EQ')) {
                                const objSelProductType = arrAllExchangeWiseProductTypes?.find(obj => obj.sDefaultProductType === ORDER_PRODUCT_TYPES.DELIVERY);
                                if (objSelProductType) {
                                    tempObj.productType = objSelProductType?.sDefaultProductType;
                                } else {
                                    tempObj.productType = arrAllExchangeWiseProductTypes[0]?.sDefaultProductType;
                                }

                            } else {
                                // for other than EQ
                                const objSelProductType = arrAllExchangeWiseProductTypes?.find(obj => obj.sDefaultProductType === ORDER_PRODUCT_TYPES.CARRYFORWARD);
                                if (objSelProductType) {
                                    tempObj.productType = objSelProductType?.sDefaultProductType;
                                } else {
                                    tempObj.productType = arrAllExchangeWiseProductTypes[0]?.sDefaultProductType;
                                }
                            }

                        }
                        if (tempObj.productType) {

                            arrNewUserPreferenceExchanges?.push(tempObj);
                        }
                    }
                }
            });
            if (arrNewUserPreferenceExchanges?.length > 0) {
                const payload = {
                    sExchange: JSON.stringify(userPreferenceExchanges?.concat(arrNewUserPreferenceExchanges))
                };
                dispatch(updateUserPreference(objActiveUserPreference, payload));

            }
        }
    }, [userPreference]);
    const navigate = useNavigate();
    const handleAddendumClik = useCallback(
        (path) => {
            navigate(path);
        },
        [navigate]
    );

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const firstKey = urlParams.keys().next().value;       // first param key
        const firstValue = urlParams.get(firstKey);
        const activeUser = getStorageWithMultiTabCheckWithoutEncryption('ACTIVE_USER');        // its value
        const arrKeys = ['userId', 'user_id'];
        // Remove query params from URL (without reload)
        const newUrl = window.location.origin + window.location.pathname;
        window.history.replaceState({}, document.title, newUrl);

        const handleDoneMessage = () => new Promise((resolve) => { });

        if (firstValue && firstValue !== activeUser && arrKeys.includes(firstKey)) {
            setStorageWithMultiTabCheckWithoutEncryption("ACTIVE_USER", firstValue?.toUpperCase());
            const userDetail = JSON.parse(getStorageWithMultiTabCheck(`${LOCAL_STORAGE_KEYS.USER_DETAILS}_${firstValue}`));
            const now = new Date();
            const options = { year: 'numeric', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false };
            const formattedTime = now.toLocaleString('en-US', options);
            const activeSession = { ...objLoginSession, data: { ...userDetail?.data }, lastLoginTime: formattedTime };
            dispatch(userSwitch(activeSession));
            onUserLoggedInActiveSession(activeSession, dispatch, handleDoneMessage, appInfo, firstValue);
        }
    }, []);

    return (
        <div className={currentPreferenceFontSize ? `fontsize-${currentPreferenceFontSize}` : `fontsize-md`}>
            {/* Maaz A: Uncomment below jsx for prodution push and put final variable.css in CDN Path */}
            {/* {
                config?.Wave?.Cloudfront_S3_URL &&
                <link rel="stylesheet" type='text/css' href={`${config?.Wave?.Cloudfront_S3_URL}${config.TenantId}/styles/variables.css`} />
            } */}
            {isAutoLocked && <AutoLockModal />}
            {getUserLoggedIn() && window.location.pathname !== LOCATIONS.HEALTHCHECK && location.pathname !== LOCATIONS.CHART && <Header />}  {/*   Ameersha N -- 24-07-2024 -- Header has been moved here to make it commong for every screen when user is logged in successfully  */}
            <Navigation />
            <CloseAccountModal />
            {modals['OPTION_CHAIN'] ? <OptionChainModal /> : null}
            {/* BT-121004 : Vinit Raut : 03-11-2023 Breeze- Hamburger Menu- Exchange Links bugfix - Start */}
            {modals['SSO_LINK_MODAL'] ? <SSOLinksModal handleAddendumClik={handleAddendumClik} /> : null}
            {/* BT-121004 : Vinit Raut : 03-11-2023 Breeze- Hamburger Menu- Exchange Links bugfix - End */}
            {modals['EVENTS_DETAILS'] ? <EventDetailsModal /> : null}
        </div>
    );
};

export default App;
